import { FC, useMemo } from 'react'

import { createImportacao, exportModeloVazio } from '../list/core/_requests'
import { useFormik } from 'formik'
import {
  Button,
  FormFileInput,
  FormInput,
  FormRadio,
  FormSelect,
  IOption,
  LoadingIndicator,
  useModal,
} from '../../../../components'
import { importacaoSchema } from './validation/importacaoSchema'
import {
  ButtonType,
  downloadArquivo,
  IconPaths,
  KTSVG,
  OptionsHelper,
  showAlert,
  showError,
} from '../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

export const ImportacaoModalForm: FC = () => {
  const { closeModal } = useModal()
  const { t } = useT()

  const initialValues = {
    empresa: undefined as IOption<number> | undefined,
    descricao: '',
    firstRowContainsColNames: false,
    file: null,
  }

  const formik = useFormik<{
    empresa: IOption<number> | undefined
    descricao: string
    firstRowContainsColNames: boolean
    file: File | null
  }>({
    enableReinitialize: true,
    initialValues,
    validationSchema: useMemo(() => importacaoSchema(t), [t]),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const result: any = await createImportacao(
          Number(values.empresa?.value),
          values.descricao,
          values.firstRowContainsColNames,
          values.file as File
        )

        const sucess = result.data.sucesso

        await showAlert({
          title: `${sucess ? 'Sucesso' : 'Erro'}`,
          text: result.data.mensagem,
          icon: sucess ? 'success' : 'error',
        })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  const handleDownloadModelo = async () => {
    try {
      const arquivo = await exportModeloVazio()
      downloadArquivo(arquivo)
    } catch (error) {
      showError(error)
    }
  }

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <div className='d-flex align-items-center justify-content-between bg-light-primary rounded border-primary border border-dashed px-4 py-3 mb-5'>
        <div className='d-flex align-items-center'>
          <KTSVG path={IconPaths.CloudDownload} className='svg-icon-2 svg-icon-primary me-3' />
          <span className='fs-6 fw-bold text-gray-800'>Não sabe o formato do arquivo?</span>
        </div>
        <Button
          onClick={handleDownloadModelo}
          icon={IconPaths.CloudDownload}
          className='btn-primary flex-shrink-0'
          size='btn-sm'
        >
          Baixar modelo
        </Button>
      </div>
      <FormSelect
        formik={formik}
        name='empresa'
        entity='empresa'
        fetchOptions={OptionsHelper.getOptionsEmpresas}
        isDisabled={formik.isSubmitting}
        isRequired
        className='mb-3'
      />
      <FormInput
        formik={formik}
        name='descricao'
        label='Descrição'
        placeholder='Digite uma descrição'
        isDisabled={formik.isSubmitting}
        isRequired
        className='mb-3'
      />

      <FormRadio<boolean>
        formik={formik}
        name='firstRowContainsColNames'
        label='Primeira linha contém nome das colunas?'
        isDisabled={formik.isSubmitting}
        isRequired
        className='mb-3'
        options={[
          { id: 1, descricao: 'Sim', value: true },
          { id: 2, descricao: 'Não', value: false },
        ]}
      />

      <FormFileInput formik={formik} name='file' label='Arquivo' isRequired />

      <div className='d-flex justify-content-center mt-5'>
        <Button type={ButtonType.Reset} onClick={closeModal} className='btn-secondary me-3'>
          {t('common.cancel')}
        </Button>

        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : 'Importar'}
        </Button>
      </div>
    </form>
  )
}
